"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const isValidProvide_1 = __importDefault(require("./isValidProvide"));
const isValueProvider = (data) => {
    return (!!data &&
        typeof data === "object" &&
        (0, isValidProvide_1.default)(data.provide) &&
        data.useValue !== undefined);
};
exports.default = isValueProvider;
